"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../core/dist");
const chatNames_1 = require("../../../app/dist/utils/chatNames");
exports.toolDef = {
    name: 'loom_append_to_chat',
    description: 'Append a new message to an existing chat document. IMPORTANT: this tool writes the role header itself (## AI: for role "ai", ## {UserName}: for role "user") — pass ONLY the reply body in the "body" argument, with NO "## AI:" / "## {name}:" header line of your own, or the chat ends up with a doubled header. Use this tool to add messages to Loom chats — do not edit chat files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            id: { type: 'string', description: 'Chat document id' },
            role: { type: 'string', enum: ['user', 'ai'], description: "Message author role. Defaults to 'ai' (the common caller); pass 'user' for the rare programmatic human turn." },
            body: { type: 'string', description: 'Message body (markdown) — the reply text ONLY. Do NOT prefix it with a "## AI:" / "## {name}:" role header; the tool adds the role header itself (including a header here produces a duplicate).' },
        },
        required: ['id', 'body'],
    },
};
async function handle(root, args) {
    const id = args['id'];
    // The MCP transport does not enforce schema `required`, and the overwhelming caller
    // is the AI — so an omitted role defaults to 'ai' rather than silently becoming a
    // user turn (which once mis-attributed an AI reply to the human). A *present* but
    // invalid role is a caller bug → fail loud instead of guessing.
    const role = args['role'] === undefined ? 'ai' : args['role'];
    if (role !== 'user' && role !== 'ai') {
        throw new Error(`loom_append_to_chat: role must be 'user' | 'ai' (got '${role}').`);
    }
    const body = args['body'];
    // Primary (agent-supplied) id → suggest-on-miss.
    const { id: resolvedId, filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, id);
    const displayName = role === 'ai' ? (0, chatNames_1.getAiName)(root) : (0, chatNames_1.getUserName)(root);
    const doc = await (0, dist_1.loadDoc)(filePath);
    const existingBody = doc.content ?? '';
    // Seam normalization (one blank line before/after the header) lives in
    // appendChatBlock — shared with the app chatReply path so the two never drift.
    const appendedBody = (0, dist_2.appendChatBlock)(existingBody, displayName, body);
    // When the AI replies, advance the read-cursor to the new last AI block so a later
    // loom_read_chat_tail returns only the human turns that follow it. A user turn never
    // moves the cursor. Header detection keys on the configured ai.model string.
    const updated = {
        ...doc,
        content: appendedBody,
        ...(role === 'ai' ? { last_ai_block: (0, dist_2.lastAiBlockIndex)(appendedBody, (0, chatNames_1.getAiName)(root)) } : {}),
    };
    delete updated._path;
    await (0, dist_1.saveDoc)(updated, filePath);
    return { content: [{ type: 'text', text: JSON.stringify({ id: resolvedId, filePath }) }] };
}
